import { Row, Spinner } from "react-bootstrap"


const Loading = () => {
  return (
    
      <Row className="justify-content-center">

      <Spinner animation="border" variant="light"/>
      </Row>
    
  )
}

export default Loading